var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMondayMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 12) scale(1.1) translate(-11.8 -12.6)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 4.6
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FF3D57",
    d: "M3.4 17 7.6 8.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFCB00",
    d: "M10.4 17 14.6 8.2"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 19.7,
    cy: 16.2,
    r: 2.8,
    fill: "#00CA72"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMondayMark);
export default __webpack_public_path__ + "static/media/monday-mark.708263a5594ffed58c8ff3275b292242.svg";
export { ForwardRef as ReactComponent };